import { flexRender, type Row, type ColumnDef } from '@tanstack/react-table'
import { cn } from '../../utils'

interface TableCardViewProps<TData> {
    rows: Row<TData>[]
    columns: ColumnDef<TData, unknown>[]
    onRowClick?: (row: TData) => void
}

export function TableCardView<TData>({
    rows,
    onRowClick,
}: TableCardViewProps<TData>) {
    return (
        <div className="flex flex-col gap-3 p-2">
            {rows.map((row) => (
                <div
                    key={row.id}
                    className={cn(
                        'rounded-lg border border-border-light bg-background-base p-4 shadow-sm',
                        onRowClick &&
                            'cursor-pointer transition-shadow hover:shadow-md'
                    )}
                    onClick={() => onRowClick?.(row.original)}
                >
                    {row.getVisibleCells().map((cell) => {
                        const header = cell.column.columnDef.header
                        const headerText =
                            typeof header === 'string' ? header : cell.column.id
                        return (
                            <div
                                key={cell.id}
                                className="flex justify-between border-b border-border-light py-1.5 last:border-0"
                            >
                                <span className="text-text-light text-sm font-medium">
                                    {headerText}
                                </span>
                                <span className="text-text-title text-sm">
                                    {flexRender(
                                        cell.column.columnDef.cell,
                                        cell.getContext()
                                    )}
                                </span>
                            </div>
                        )
                    })}
                </div>
            ))}
        </div>
    )
}
